/**
 * Strips all non-digit characters from a RUC string and caps at 11 chars.
 */
export const formatRuc = (value: string): string => {
  if (!value) return "";
  return value.replace(/\D/g, "").slice(0, 11);
};

/**
 * Validates a Peruvian RUC number.
 * - Must be exactly 11 digits
 * - Must start with 10, 15, 17, or 20
 * - Check digit validated with modulo-11 weights [5,4,3,2,7,6,5,4,3,2]
 */
export const checkRuc = (ruc: string): boolean => {
  if (!ruc) return false;

  const clean = ruc.replace(/\D/g, "");
  if (clean.length !== 11) return false;

  const prefix = clean.slice(0, 2);
  if (!["10", "15", "17", "20"].includes(prefix)) return false;

  const weights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  const digits = clean.split("").map(Number);
  const total = weights.reduce((acc, w, i) => acc + w * digits[i], 0);
  const remainder = 11 - (total % 11);

  let expectedCheck: number;
  if (remainder === 10) expectedCheck = 0;
  else if (remainder === 11) expectedCheck = 1;
  else expectedCheck = remainder;

  return digits[10] === expectedCheck;
};
